export class RemoveAssigneeModel {
    public unixTimeStamp: number;
    public editorId: string;
}
